import { render, staticRenderFns } from "./imageBanner.vue?vue&type=template&id=8db46ce2&scoped=true&"
import script from "./imageBanner.vue?vue&type=script&lang=js&"
export * from "./imageBanner.vue?vue&type=script&lang=js&"
import style0 from "./imageBanner.vue?vue&type=style&index=0&id=8db46ce2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db46ce2",
  null
  
)

export default component.exports